module.exports = __webpack_public_path__ + "static/media/herpimg.b195703e.PNG";